export class ExternalUserNotFoundError extends Error {
  constructor() {
    super(`External user not found`);
  }
}
